import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

import { EventFiltersI } from '../types/types'
import { EventFeed } from './EventFeed'
import { TraceLogHeader } from './TraceLogHeader'

// The 112px here are the Header, Tab and padding height values
export const TRACE_LOG_PANEL_HEIGHT = 'calc(100vh - 135px)'

export const TraceLogContent = ({ incident }: EventFiltersI) => {
  return (
    <Box>
      <TraceLogHeader />
      <Tabs
        borderColor='transparent'
        fontWeight='500'
        isFitted
        isLazy
        px='24px'
        py='12px'
        w='100%'
      >
        <TabList>
          <Tab
            _selected={{
              color: 'components.tab.active',
              borderBottomColor: 'components.tab.active',
              opacity: 1,
            }}
            opacity={0.4}
          >
            <Box alignItems='center' display='inline-flex'>
              Device
            </Box>
          </Tab>
          <Tab
            _selected={{
              color: 'components.tab.active',
              borderBottomColor: 'components.tab.active',
              opacity: 1,
            }}
            opacity={0.4}
          >
            <Box alignItems='center' display='inline-flex'>
              Facility
            </Box>
          </Tab>
        </TabList>
        <TabPanels px='0'>
          <TabPanel px='0' py='8px'>
            <EventFeed
              filters={{ deviceId: incident?.devices?.[0]?.id }}
              incident={incident}
            />
          </TabPanel>
          <TabPanel px='0' py='8px'>
            <EventFeed
              filters={{ facilityId: incident?.facility?.id }}
              incident={incident}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
